const u = up.util;
up.DestructorPass = class DestructorPass {
    constructor(fragment, options) {
        this._fragment = fragment;
        this._options = options;
    }
    run() {
        for (let cleanable of this._selectCleanables()) {
            let registry = u.pluckKey(cleanable, 'upDestructors');
            registry === null || registry === void 0 ? void 0 : registry.clean(cleanable);
        }
    }
    _selectCleanables() {
        const selectOptions = Object.assign(Object.assign({}, this._options), { destroying: true });
        return up.fragment.subtree(this._fragment, '.up-can-clean', selectOptions);
    }
};
